export const CardDifficultyMode = {
  Answer: 'Answer',
  AnswerTimeExceeded: 'AnswerTimeExceeded',
  EasyHardWrong: 'EasyHardWrong',
  Wrong: 'Wrong',
} as const;

export type CardDifficultyMode = typeof CardDifficultyMode[keyof typeof CardDifficultyMode];
